<template>
    <div v-if="enrollment.id">
        <card-header title="Course Responses" icon="fa-comment"></card-header>
        <card-body>

<!--            <json-viewer :value="enrollment.courses.course_outline"></json-viewer>-->
<!--            <json-viewer :value="inputComponents"></json-viewer>-->
<!--            <json-viewer :value="enrollment.enrollment_data"></json-viewer>-->

            <card-list>
                <template v-for="s in inputComponents">
                    <subheader-list-item :title="s.title" icon="fa-list-alt" />

                    <template v-for="c in s.components">

                        <subheader-list-item :title="c.title" :icon="{'fa-memo-pad': c.type === 'LESSON', 'fa-message-question': c.type === 'QUIZ', 'fa-location-check': c.type === 'CHECKPOINT'}" />

                        <card-list-item v-for="i in c.inputs">
                            <template v-slot:icon><i class="far fa-fw fa-keyboard"></i></template>
                            <template v-slot:content>
                                <div class="meta">{{ i.component.replace('DropdownField', 'Dropdown Select Question').replace('TextArea', 'Text Area Question').replace('TextField', 'Text Field Question').replace('CheckBox', 'Checkbox/Switch') }}</div>

                                <div class="tile-title">
                                    <span v-if="i.content.title">{{ i.content.title }}</span>
                                    <span v-else>Untitled Input Block<i class="fad fa-exclamation-triangle ml-2 has-text-warning"></i></span>
                                </div>
                                <div class="meta mt-1" v-if="componentData(i.content.id).length">{{ componentData(i.content.id)[0].value }}</div>
                                <div class="meta mt-1 is-italic" v-else>No response provided.</div>
                            </template>
                            <template v-slot:status>
                                <div class="stats">
                                    <span class="stat" v-if="componentData(i.content.id).length>1"><i class="far fa-triangle"></i>{{ componentData(i.content.id).length }}</span>
                                </div>
                            </template>
                            <template v-slot:details>
                                <div class="tile-details mt-4">
                                    <div class="data mt-1 mb-4">
                                        <data-row mini title="Response Changes">{{ componentData(i.content.id).length }}</data-row>
                                        <data-row mini title="Field">{{ i.content.id }}</data-row>
                                    </div>
                                    <div class="data mt-1" v-for="a in componentData(i.content.id)">
                                        <data-row mini title="Date">{{ a.created_at | moment('MMM Do YYYY, h:mm:ss a') }}</data-row>
                                        <data-row mini title="Response">{{ a.value }}</data-row>
                                    </div>
                                </div>
                            </template>
                        </card-list-item>
                    </template>
                </template>

            </card-list>

        </card-body>
    </div>
</template>
<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import ConferenceTile from "../../../components/tiles/ConferenceTile";

    import {client as http} from "@/http_client";
    import moment from "moment";
    import ApplicantTile from "../../../components/tiles/ApplicantTile.vue";
    import CardListItem from "../../../TIER/components/CardListItem.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {CardListItem, ApplicantTile, ConferenceTile, ContainerListItem, SeparatorListItem, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                enrollment: {}
            };
        },
        methods: {
            loadEnrollment: function (force) {
                this.$emit('loading', true);
                http.get('courses/new/enrollment/' + this.props.enrollId, {force}).then(response => {
                    this.enrollment = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function () {
                this.loadEnrollment(true);
            },
            componentData(id) {
                let answers = this.enrollment.enrollment_data.filter(d => d.field === id).sort((a, b) => b.id - a.id);

                answers.forEach(a => {
                    if (a.value.answer) a.value = a.value.answer;
                });
                return answers;
            }
        },
        computed: {
            inputComponents: function () {
                if (this.enrollment.id) {
                    let sections = {};
                    this.enrollment.courses.course_outline.forEach(outline => {
                        outline.sections.section_components.forEach(component => {
                            let content = component.components.content.content;

                            if (component.components.type === 'CHECKPOINT') {
                                if (!sections[outline.id]) {
                                    sections[outline.id] = {
                                        title: outline.title,
                                        components: {}
                                    };
                                }
                                if (!sections[outline.id].components[component.component_id]) {
                                    sections[outline.id].components[component.component_id] = {
                                        title: component.components.title,
                                        type: component.components.type,
                                        inputs: []
                                    };
                                }

                                sections[outline.id].components[component.component_id].inputs.push({
                                    content: {
                                        id: component.components.content.attributes.id,
                                        title: component.components.title,
                                    },
                                    component: 'Checkpoint: ' + component.components.content.attributes.type.replace('ReflectionCheckpoint', 'Reflection/Open Question')
                                });

                            } else if (content.length) {
                                content.forEach(c => {
                                    if (c.component === 'DropdownField' || c.component === 'TextField' || c.component === 'TextArea' || c.component === 'CheckBox') {

                                        if (!sections[outline.id]) {
                                            sections[outline.id] = {
                                                title: outline.title,
                                                components: {}
                                            };
                                        }
                                        if (!sections[outline.id].components[component.component_id]) {
                                            sections[outline.id].components[component.component_id] = {
                                                title: component.components.title,
                                                type: component.components.type,
                                                inputs: []
                                            };
                                        }

                                        sections[outline.id].components[component.component_id].inputs.push(c);
                                    }
                                });
                            }

                        });
                    });

                    return sections;
                } else {
                    return false;
                }
            }
        },
        watch: {
            'props.enrollId': function () {
                this.loadEnrollment(true);
            }
        },
        mounted: function () {
            this.loadEnrollment();
        }
    };
</script>

<style lang="scss" scoped>

    .tile-title {
        font-size: .9rem;
        font-weight: 700;
    }
</style>
